import {forwardRef} from "react";
import {BaseSelect} from "./BaseSelect";
import {
    inter,
    primaryPink,
    primaryPurple,
    secondaryPurple,
    white,
} from "../../Theme";
import caretDownIcon from "../../resources/images/ic-caretDown.svg";
import {OptionWithDivider} from "./OptionWithDivider";

export const SideMenuSelect = forwardRef(function SideMenuSelect(props, ref) {
    const {options, disabled, ...otherProps} = props;

    return (
        <BaseSelect
            options={options}
            disabled={disabled}
            customComponents={{Option: OptionWithDivider}}
            styles={{
                container: (baseStyles) => ({
                    ...baseStyles,
                    marginBottom: "3px",
                    justifyContent: "center",

                }),
                control: (baseStyles, { isFocused }) => ({
                    ...baseStyles,
                    width: "100%",
                    padding: "8px 40px 8px 10px",
                    color: white,
                    fontFamily: inter,
                    fontSize: "16px",
                    backgroundImage: !disabled ? `url(${caretDownIcon})` : "none",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 15px top 50%",
                    backgroundSize: "20px",
                    textAlign: "left",
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: secondaryPurple,
                    boxShadow: isFocused
                        ? "0 0 0 2px white"
                        : "none",
                }),
                placeholder: (baseStyles) => ({
                    ...baseStyles,
                }),
                input: (baseStyles) => ({
                    ...baseStyles
                }),
                valueContainer: (baseStyles) => ({
                    ...baseStyles,
                    gap: "10px",
                    display: "flex",
                    flexWrap: "none",
                }),
                menu: (baseStyles, {options}) => ({
                    ...baseStyles,
                    background: secondaryPurple,
                    overflow: "hidden",
                    zIndex: "100",
                    color: white,
                    fontFamily: inter,
                    fontSize: "16px",
                    transform: `translate(0, 8px)`,
                    border: "1px solid #FFFFFF33"
                }),
                menuList: (baseStyles) => ({
                    ...baseStyles,

                    "::-webkit-scrollbar": {
                        width: "4px",
                        height: "0px",
                    },
                    "::-webkit-scrollbar-track": {
                        background: secondaryPurple
                    },
                    "::-webkit-scrollbar-thumb": {
                        background: primaryPurple
                    },
                    "::-webkit-scrollbar-thumb:hover": {
                        background: primaryPink
                    }
                }),
                option: (baseStyles, { isFocused }) => ({
                    ...baseStyles,
                    cursor: "pointer",
                    padding: "12px 0",
                    textUnderlineOffset: "2px",
                    boxShadow: isFocused
                        ? "0 2px white"
                        : "none",
                }),
                noOptionsMessage: (baseStyles) => ({
                    ...baseStyles,
                    padding: "12px 12px",
                    color: white,
                    fontFamily: inter,
                    fontSize: "16px",
                    fontWeight: "700",
                    textAlign: "center",
                    boxShadow: "0 2px 0 0 #4D2F78",
                    cursor: "pointer",
                }),
                singleValue: (baseStyles) => ({
                    ...baseStyles,
                    color: !disabled ? "white" : "rgba(255, 255, 255, 0.5)",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                }),
                clearIndicator: (baseStyles) => ({
                    ...baseStyles
                }),
            }}
            {...otherProps}
        />
    )
})